import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { isHtmlCustomerNote } from "utils/customerNoteContent";

function CustomerNoteContent({ note }) {
  const content = String(note?.note || "");

  if (!content) {
    return (
      <MDTypography variant="body2" color="text">
        —
      </MDTypography>
    );
  }

  if (!isHtmlCustomerNote(note)) {
    return (
      <MDTypography variant="body1" sx={{ whiteSpace: "pre-wrap" }}>
        {content}
      </MDTypography>
    );
  }

  return (
    <MDBox
      sx={{
        typography: "body1",
        "& table": { borderCollapse: "collapse", width: "100%" },
        "& th, & td": { border: "1px solid #ddd", p: 1 },
        "& img": { maxWidth: "100%" },
        overflowX: "auto",
      }}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
}

CustomerNoteContent.propTypes = {
  note: PropTypes.shape({
    note: PropTypes.string,
  }).isRequired,
};

export default CustomerNoteContent;
